import PropTypes from 'prop-types';
import React from 'react';
function Price(_ref) {
  var {
    regular,
    special
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "product-price-listing"
  }, regular.value === special.value && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "sale-price font-semibold"
  }, regular.text)), special.value < regular.value && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "sale-price text-critical font-semibold"
  }, special.text), ' ', /*#__PURE__*/React.createElement("span", {
    className: "regular-price font-semibold"
  }, regular.text)));
}
Price.propTypes = {
  regular: PropTypes.shape({
    value: PropTypes.number,
    text: PropTypes.string
  }).isRequired,
  special: PropTypes.shape({
    value: PropTypes.number,
    text: PropTypes.string
  }).isRequired
};
export { Price };